import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { jitteredPollMs } from '~/utils/jitter';

import { RECOVERY_LIVE_POLL_MS, refetchOnShow } from '../constants/polling';
import { getFailurePoints } from '../services/recovery.service';

/**
 * A run's failure points (per-stage newest attempt, retryable, blockedBy). Polls
 * only while the run is live (a retry just re-opened it), since a closed run's
 * ledger does not move on its own; control mutations invalidate it on settle.
 * `enabled` lets the page skip the read entirely when it would not render it.
 */
export function useRecoveryFailurePoints(runRef: string, isLive: boolean, enabled = true) {
  return useQuery({
    queryKey: queryKeys.catalogService.runFailurePoints(runRef),
    queryFn: () => getFailurePoints(runRef),
    enabled: enabled && !!runRef,
    refetchInterval: (query) => (isLive ? jitteredPollMs(query, RECOVERY_LIVE_POLL_MS) : false),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: (query) =>
      refetchOnShow(query.state.dataUpdatedAt, isLive ? RECOVERY_LIVE_POLL_MS : false),
  });
}
